import EmblaCarousel from "embla-carousel";

function initEmblaCarousels() {
  document.querySelectorAll(".embla-carousel").forEach((emblaNode) => {
    // Skip if already initialized
    if (emblaNode.dataset.emblaInitialized) return;
    emblaNode.dataset.emblaInitialized = "true";

    const viewport = emblaNode.querySelector(".embla__viewport");
    const prevBtn = emblaNode.querySelector(".embla__button--prev");
    const nextBtn = emblaNode.querySelector(".embla__button--next");
    const dotsContainer = emblaNode.querySelector(".embla__dots");

    const embla = EmblaCarousel(viewport, {
      align: "start",
      containScroll: "trimSnaps",
      slidesToScroll: 1,
    });

    // Arrow buttons
    if (prevBtn) prevBtn.addEventListener("click", () => embla.scrollPrev());
    if (nextBtn) nextBtn.addEventListener("click", () => embla.scrollNext());

    // Dot navigation
    if (dotsContainer) {
      const buildDots = () => {
        const slides = embla.scrollSnapList();
        dotsContainer.innerHTML = "";
        slides.forEach((_, index) => {
          const dot = document.createElement("button");
          dot.className = "embla__dot";
          dot.type = "button";
          dot.addEventListener("click", () => embla.scrollTo(index));
          dotsContainer.appendChild(dot);
        });
        updateDots();
      };

      const updateDots = () => {
        const selected = embla.selectedScrollSnap();
        dotsContainer.querySelectorAll(".embla__dot").forEach((dot, i) => {
          dot.classList.toggle("embla__dot--active", i === selected);
        });
      };

      embla.on("init", buildDots);
      embla.on("select", updateDots);
      embla.on("reInit", buildDots);
    }

    // Caption width matching for listing carousels
    if (emblaNode.classList.contains("listing-photo-carousel")) {
      const setCaptionWidths = () => {
        emblaNode.querySelectorAll(".embla__slide").forEach((slide) => {
          const img = slide.querySelector("img");
          const caption = slide.querySelector(".carousel-caption");
          if (img && caption) {
            caption.style.width = img.offsetWidth + "px";
          }
        });
      };
      embla.on("init", setCaptionWidths);
      embla.on("resize", setCaptionWidths);
    }
  });
}

document.addEventListener("turbolinks:load", initEmblaCarousels);
